import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalFullWidthMode } from '../../../../shared/_constants';

@Component({
  selector: 'app-adjustement-modal-template',
  templateUrl: './adjustment-modal-template.component.html',
  styleUrls: ['./adjustment-modal-template.component.css'],
})
export class AdjustmentModalTemplateComponent {
  @Input() title = 'Default title';
  @Input() showHeader = true;
  @Input() spinnerVisible = false;
  isFullScreen = false;

  constructor(private activeModal: NgbActiveModal) {}

  public resize() {
    if (this.isFullScreen) {
      const el_fs_modal = document.getElementsByClassName(ModalFullWidthMode.FULL_SCREEN_CSS_CLASS)[0];
      el_fs_modal.classList.remove(ModalFullWidthMode.FULL_SCREEN_CSS_CLASS);
      el_fs_modal.classList.add(ModalFullWidthMode.CSS_CLASS);
      el_fs_modal.classList.add(ModalFullWidthMode.FULL_SCREEN_EXIT_CSS_CLASS);
    } else {
      const el_modal = document.getElementsByClassName(ModalFullWidthMode.CSS_CLASS)[0];
      el_modal.classList.add(ModalFullWidthMode.FULL_SCREEN_CSS_CLASS);
      el_modal.classList.remove(ModalFullWidthMode.CSS_CLASS);
      el_modal.classList.remove(ModalFullWidthMode.FULL_SCREEN_EXIT_CSS_CLASS);
    }

    this.isFullScreen = !this.isFullScreen;
  }

  public close(val: any) {
    this.activeModal.close(val);
  }
}
